import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reconnection-error',
  templateUrl: './reconnection-error.component.html'
})
export class ReconnectionErrorComponent implements OnInit {

  constructor(public dialog: NgbActiveModal) {}

  public ngOnInit(): void {}

  public onSubmit(): void {
    this.dialog.close();
  }
}
